<canvas #canvasHtml [style.cursor]="currentCursor"></canvas>
